import React from 'react'
import { Icon, SingleOptionSelectorComponent } from '@front/squirtle'
import { Grid } from '@mui/material'

const ExtraControls = (props) => {
  const { options, isMinimized } = props

  return (
    <Grid container justifyContent={'center'}>
      {
        _.map(options, (option) => (
          <Grid
            key={option.label}
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            size={isMinimized ? 12 : 6}>
            {!!option.icon && <Icon icon={option.icon} />}
            <SingleOptionSelectorComponent
              optionLabel={isMinimized ? null : option.label}
              value={option.value}
              onChange={option.onChange}
              getOptionLabelProps={() => ({
                slotProps: { typography: { sx: { fontSize: 13, fontWeight: 600 } } },
                labelPlacement: isMinimized ? 'end' : 'bottom'
              })}
            />
          </Grid>
        ))
      }
    </Grid>
  );
}
export default React.memo(ExtraControls)
